import { useState, useCallback, useRef, useEffect } from 'react';

interface UsePDFViewerReturn {
  isOpen: boolean;
  pdfUrl: string;
  openPDF: (url: string) => void;
  closePDF: () => void;
}

// État global persistant pour éviter la réinitialisation lors des re-renders
const globalPDFState = {
  isOpen: false,
  pdfUrl: '',
  listeners: new Set<() => void>()
};

// Debug: Exposer l'état global pour inspection
(window as any).globalPDFState = globalPDFState;

export const usePDFViewer = (): UsePDFViewerReturn => {
  const [, forceUpdate] = useState({});
  const listenerRef = useRef<() => void>();

  // Forcer un re-render quand l'état global change
  const triggerUpdate = useCallback(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    // Enregistrer le listener pour les mises à jour
    listenerRef.current = triggerUpdate;
    globalPDFState.listeners.add(triggerUpdate);

    // Nettoyage lors du démontage
    return () => {
      if (listenerRef.current) {
        globalPDFState.listeners.delete(listenerRef.current);
      }
    };
  }, [triggerUpdate]);

  const openPDF = useCallback((url: string) => {
    console.log('usePDFViewer - openPDF appelé avec URL:', url);
    if (!url) {
      console.error('usePDFViewer - URL vide, annulation');
      return;
    }
    
    globalPDFState.pdfUrl = url;
    globalPDFState.isOpen = true;
    
    console.log('usePDFViewer - État global après ouverture:', globalPDFState);
    console.log('usePDFViewer - Nombre de listeners:', globalPDFState.listeners.size);
    
    // Notifier tous les listeners
    globalPDFState.listeners.forEach((listener, index) => {
      console.log(`usePDFViewer - Notification du listener ${index}`);
      try {
        listener();
      } catch (error) {
        console.error(`Erreur lors de la notification du listener ${index}:`, error);
      }
    });
  }, []);

  const closePDF = useCallback(() => {
    console.log('usePDFViewer - closePDF appelé');
    
    globalPDFState.isOpen = false;
    globalPDFState.pdfUrl = '';
    
    // Notifier tous les listeners
    globalPDFState.listeners.forEach(listener => listener());
  }, []);

  return {
    isOpen: globalPDFState.isOpen,
    pdfUrl: globalPDFState.pdfUrl,
    openPDF,
    closePDF,
  };
};
